export default __webpack_public_path__ + "static/The Home_Image 5_carousel 5@2x-d7380eab4189a5f0f13e49a80add9f6e.jpg";